import { render, staticRenderFns } from "./userUpdate.vue?vue&type=template&id=0799b971&"
import script from "./userUpdate.vue?vue&type=script&lang=js&"
export * from "./userUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports